import { Box, Divider, Drawer, List, Stack, Toolbar } from "@mui/material";
import SidebarItem from "./SidebarItem";
import { useSelector } from "react-redux";
import { useState } from "react";
import sizeConfigs from "../configs/sizeConfigs";
import colorConfigs from "../configs/colorConfigs";
import assets from "../assets";
import appRoutes from "../routes/appRoutes";
import { RootState } from "../redux/store";
import SidebarItemCollapse from "./SidebarItemCollapse";
import dayjs from 'dayjs';
import versionConfig from "../configs/versionConfig";
import SignInDialog from "./common/SignInDialog";
import React from "react";

const Sidebar = () => {
  const [isHovered, setIsHovered] = useState(false);
  const authData = useSelector((state: RootState) => state.auth);
  const currentYear = dayjs().year();

  return (
    <Drawer
      variant="permanent"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={{
        width: isHovered ? sizeConfigs.sidebar.width : sizeConfigs.sidebar.halfwidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          transition: "width 0.3s",
          boxShadow: '0px 7px 10px 5px rgba(50, 50, 50, 0.6)',
          width: isHovered ? sizeConfigs.sidebar.width : sizeConfigs.sidebar.halfwidth,
          boxSizing: "border-box",
          borderRight: "0px",
          fontWeight: "bold",
          backgroundColor: colorConfigs.sidebar.bg,
          color: colorConfigs.buttons.sidebar,
          '&::-webkit-scrollbar': { display: 'none' },
          msOverflowStyle: 'none', // Internet Explorer 10+
          scrollbarWidth: 'none', // Firefox
          zIndex: 10,
        }
      }}
    >
      <List disablePadding>
        <Toolbar disableGutters sx={{ height: "100px", paddingX: isHovered ? 1 : 0.7, transition: "all 0.3s ease", }}>
          <Stack data-testid="Stack-rp9j"
            sx={{ width: "100%", height: "80px" }}
            direction="row"
            justifyContent="center"
          >
            <Box data-testid="Box-3ynf"
              sx={{
                height: "100%",
                width: isHovered ? sizeConfigs.sidebar.width : sizeConfigs.sidebar.halfwidth,
                maxHeight: "60px",
                transition: "all 0.3s ease",
                backgroundColor: colorConfigs.sidebar.bg,
                padding: 1,
                borderRadius: 1,
                marginTop: { xs: 1, md: 1 },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box data-testid="Box-x950"
                component="img"
                sx={{
                  width: "auto",
                  height: isHovered ? "70px" : "70px",
                  transition: "all 0.3s ease",
                  objectFit: "contain",
                }}
                alt="Premier Biotech OT Scan Logo"
                src={isHovered ? assets.images.pbiologoexpand : assets.images.pbiologosmall}

              />
            </Box>

          </Stack>
        </Toolbar>
        {appRoutes.map((route: any, index: any) => {
          if (authData !== undefined && !authData.isAuthenticated) return <SignInDialog isAuthenticated={authData.isAuthenticated} />
          if (route.sidebarProps && authData !== undefined) {
            if (route.child) {
              return <SidebarItemCollapse item={route} key={index} isHovered={isHovered} />;
            } else {
              return <SidebarItem item={route} key={index} isHovered={isHovered} />;
            }
          }
          return null;
        })}
      </List>
      <Stack data-testid="Stack-hgv3"
        sx={{
          color: '#555',
          marginTop: "auto", // Pushes the footer to the bottom
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          paddingBottom: "20px",
          gap: 1,
        }}
      >
        {isHovered && <Box data-testid="Box-h60y">{currentYear}&nbsp;Premier Biotech®</Box>}
        <Box data-testid="Box-7ilc">{versionConfig.version}</Box>
      </Stack>
    </Drawer>
  );
};

export default Sidebar;
